const breathing = {
  props: {
    breathing: Boolean,
  },
  data: () => ({
    shouldBreath: false,
  }),
  watch: {
    active: {
      handler(nv) {
        if (!nv) {
          setTimeout(() => {
            this.startBreathing();
          }, 1500);
        } else {
          this.shouldBreath = false;
        }
      },
      immediate: true,
    },
    breathing(nv) {
      if (nv) {
        this.startBreathing();
      } else {
        this.shouldBreath = false;
      }
    },
  },
  methods: {
    startBreathing() {
      if (!this.active && this.breathing) {
        this.shouldBreath = true;
      }
    },
  },
};

export default breathing;
